import { FC, useState } from 'react';
import styles from './QuickViewImageBadges.module.scss?module';
import useViewports from '../../../../../../../Hooks/useViewports';

export interface QuickViewImageBadgesProps {
  isClearanceFlavour: boolean;
  clearanceLabel: string;
  isNew: boolean;
  hasPromo: boolean;
  promoText?: string;
  imageOverlayUri?: string;
}

type Badge = {
  text: string;
  className: string;
};

const QuickViewImageBadges: FC<QuickViewImageBadgesProps> = ({
  isClearanceFlavour,
  clearanceLabel,
  isNew,
  hasPromo,
  promoText,
  imageOverlayUri,
}) => {
  const badges: Badge[] = [];
  const { xs, sm } = useViewports();
  const isMobile = xs || sm;

  if (isClearanceFlavour && clearanceLabel) {
    badges.push({ text: clearanceLabel, className: styles.SlantedBadgePink });
  }

  if (hasPromo && promoText) {
    badges.push({ text: promoText, className: styles.SlantedBadgeRed });
  }

  const sortedBadges = [...badges].sort(
    (a, b) => a.text.length - b.text.length
  );

  return (
    <>
      <div className="position-relative">
        <div
          className={styles.LeftBadges}
          style={{
            height: imageOverlayUri ? '90px' : 'auto',
          }}
        >
          {isNew && <div className={styles.SlantedBadgeOrange}>Neu</div>}
          {sortedBadges.map((badge) => (
            <div key={badge.text} className={badge.className}>
              {badge.text}
            </div>
          ))}
        </div>

        {imageOverlayUri && (
          <img
            src={imageOverlayUri}
            className={styles.RightTopOverlay}
            alt="Overlay"
          />
        )}
      </div>
    </>
  );
};

export default QuickViewImageBadges;
